import { push } from 'react-router-redux';
import { all, takeEvery, put, delay } from 'redux-saga/effects';

import * as actionTypes from '../constants/actionTypes';
import * as authAction from '../actions';

import axios from '../services';
import toaster from '../utils/toaster';

function* dashboardStatsRequest(action) {
  try {
    yield put(authAction.showLoader());
    const p = action.payload || {};
    const params = new URLSearchParams();
    if (p.from && p.to) {
      params.set('from', p.from);
      params.set('to', p.to);
    } else if (p.fy !== undefined && p.fy !== null && p.fy !== '') {
      params.set('fy', String(p.fy));
    }
    const q = params.toString();
    const url = q ? `/dashboard/view?${q}` : '/dashboard/view';
    const response = yield axios.get(url);

    if (response.status === 200) {
      yield put(authAction.dashbordStatsRequestSuccess(response.data.data));
      yield put(authAction.hideLoader());
    } else {
      yield put(authAction.hideLoader());
      toaster(response.message);
    }
  } catch (error) {
    yield put(authAction.hideLoader());
  }
}

export default function* rootsaga() {
  yield all([yield takeEvery(actionTypes.DASHBOARD_STATS_REQUEST, dashboardStatsRequest)]);
}
